module.exports = __webpack_public_path__ + "img/knife-and-fork.a64db718.png";